import { INVOICES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/invoices_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'invoicesIndex',
	'invoicesTable',
	// The project Invoices tab splits into two lists that must not share filters,
	// pagination or records — one per sub-tab.
	'projectDirectInvoicesTable',
	'projectWorkOrderInvoicesTable',
	'workOrderAssociatedInvoices',
	'ATTENTION_DASHBOARD_PENDING_APPROVAL_INVOICES',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
